import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Empty_LetterRequestCustomer_ScheduleTable_Interface, LetterRequestCustomer_ScheduleTable_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable_Interface';
import { Empty_LetterRequestCustomer_Schedule_Interface, LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';

@Component({
  selector: 'app-ScheduleLetterForm',
  templateUrl: './ScheduleLetterForm.component.html',
  styleUrls: ['./ScheduleLetterForm.component.css']
})
export class ScheduleLetterFormComponent implements OnInit {

  @Input() inner_Letter_record: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  HourList: Array<number> = []

  constructor(
    private modalService: BsModalService,
    private DeviceBehfa_Service: DeviceBehfaService,
    private ExpertCalibration_Service: ExpertCalibrationService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private MailMessage_Service: MailMessageService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {
    this.HourList = Array(24).fill(1).map((x, i) => i);

    this.ScheduleForm = new FormGroup({
      id: new FormControl(),
      dsc: new FormControl(null),
      persianDate: new FormControl(null, Validators.required),
      startHour: new FormControl("9", Validators.required),
      endHour: new FormControl("15", Validators.required),
      comment: new FormControl("0", Validators.required),
    })

    this.MailMessageForm_Schedule = new FormGroup({
      mailmessage_id: new FormControl("0", Validators.required),
    })

    this.ReadData_MailMessage_Shcedule()
  }

  DeviceFormList: Array<LetterRequestCustomer_Device_Interface> = []
  OnInitail_Form() {
    this.LetterRequestCustomer_Service.GetSingle(this.inner_Letter_record.id,1).subscribe(
      data => {
        this.Schedule_DataList = data['schedules']
        this.FormAdded_MailMessage_Schedule = data['mail_Schedules']
        this.DeviceFormList = data['device']
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  //#region  کارشناس کالیبراسیون

  ShowDelete_Schedule: boolean = false

  Set_ShowDelete_Schedule() {
    this.ShowDelete_Schedule = !this.ShowDelete_Schedule
  }


  ScheduleForm: FormGroup
  Schedule_DataList: Array<LetterRequestCustomer_Schedule_Interface> = []


  get_ScheduleForm_startHour() {
    return this.ScheduleForm.get('startHour') as FormControl;
  }

  get_ScheduleForm_endHour() {
    return this.ScheduleForm.get('endHour') as FormControl;
  }

  get_ScheduleForm_Dsc() {
    return this.ScheduleForm.get('dsc') as FormControl;
  }

  get_ScheduleForm_Comment() {
    return this.ScheduleForm.get('comment') as FormControl;
  }

  get_ScheduleForm_persianDate() {
    return this.ScheduleForm.get('persianDate') as FormControl;
  }

  ScheduleForm_Submit() {
    var Checker: boolean = false

    var checker_Persian: string = ''
    for (let detail of this.Schedule_DataList) {
      if (detail.persianDate == this.get_ScheduleForm_persianDate().value && detail.del == false) {
        Checker = true
        break
      }
    }

    if (Checker) {
      this.Alertify_Service.ErrorMessage("تاریخ نظر در لیست ثبت شده است")
    }
    else {
      var temp: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()
      temp.persianDate = this.get_ScheduleForm_persianDate().value
      temp.dsc = this.get_ScheduleForm_Dsc().value
      temp.startDate = Number(this.get_ScheduleForm_startHour().value)
      temp.endDate = Number(this.get_ScheduleForm_endHour().value)
      temp.comment = Number(this.get_ScheduleForm_Comment().value)
      temp.del = false
      temp.expert = []
      this.Schedule_DataList.push(temp)

      this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
    }
  }

  ScheduleForm_Delete(id) {
    this.Schedule_DataList.splice(id,1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  ScheduleForm_showPrint(id) {
    this.Schedule_DataList[id].showPrint = !this.Schedule_DataList[id].showPrint
    this.LetterRequestCustomer_Service.ChangeSchduleShowPrint(this.Schedule_DataList[id].id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage(" اعمال شد")
      }
    )
  }

  ScheduleForm_isOut(id) {
    this.Schedule_DataList[id].isOut = !this.Schedule_DataList[id].isOut
    this.LetterRequestCustomer_Service.ChangeSchduleIsout(this.Schedule_DataList[id].id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage(" اعمال شد")
      }
    )
  }

  modalRef_ExpertCalibration: any;
  Procssing_ExpertCalibration: boolean = false
  Proccessing_Schedule: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()

  openModal_ExpertCalibration(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_ExpertCalibration = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  ExpertCalibrationpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.ExpertCalibrationpage = 0
  }

  ReadData_ExpertCalibration() {
    this.Procssing_ExpertCalibration = true

    this.ExpertCalibration_Service.GetActiveList(false, true, true).subscribe(
      data => {
        this.DataList_ExpertCalibration = data
        this.Procssing_ExpertCalibration = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []

  Set_Selected_ExpertCalibration_Record(item: ExpertCalibration_Interface) {


    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.expert) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("کارشناس مورد نظر در لیست ثبت شده است")
    }
    else {

      item.del = false
      item.id_temp = 0

      this.Proccessing_Schedule.expert.push(item)
      //this.modalRef_ExpertCalibration.hide()
    }

  }

  ExpertCalibration_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.expert[id].del = true
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  ExpertCalibration_Visible(item: ExpertCalibration_Interface) {

    this.LetterRequestCustomer_Service.SetLetterRequestCustomerExpertsVisible(item.id_temp).subscribe(
      data => {
        item.visible = !item.visible
        this.Alertify_Service.SuccessMessage("تغییر اعمال شد")
      }
    )

  }

  DeviceBehfa_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.deviceBehfa[id].del = true
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }


  Change_Seleted_ExpertCalibration_Record(Record: LetterRequestCustomer_Schedule_Interface, indexer: number) {
    for (let item of Record.expert) {
      if (item.del == false) {
        item.seleted = false
      }
    }
    Record.expert[indexer].seleted = true
  }

  //#endregion


  //#region  Device Behfa

  DataList_DeviceBehfa_Schedule:Array<string>=[]
  modalRef_DeviceBehfa: any;
  modalRef_DeviceBehfaSchedule: any;
  Temp_DeviceBehfa_Record:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  openModal_DeviceBehfa(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface,template: TemplateRef<any>) {
    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.deviceBehfa) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("تجهیز بهفا مورد نظر در لیست ثبت شده است")
    }
    else {
      item.del = false
      item.id_temp = 0

      if(item.deviceBehfa_Schedule.length>0)
      {
        this.modalRef_DeviceBehfa.hide()
        this.modalRef_DeviceBehfaSchedule = this.modalService.show(template);
        this.DataList_DeviceBehfa_Schedule = item.deviceBehfa_Schedule
        this.Temp_DeviceBehfa_Record=item
      }
      else
      {
        this.DataList_DeviceBehfa_Schedule=[]
        this.Proccessing_Schedule.deviceBehfa.push(item)
      }
    }
  }

  Set_Selected_DeviceBehfa_Record_Co(template: TemplateRef<any>,Status:number) {
    this.modalRef_DeviceBehfaSchedule.hide()

    this.modalRef_DeviceBehfa = this.modalService.show(template);
    this.DataList_DeviceBehfa_Schedule = []
    if(Status==1)
    {
      this.Proccessing_Schedule.deviceBehfa.push(this.Temp_DeviceBehfa_Record)
    }
  }


  //#endregion

  
  //#region MailMessage
  MailMessageForm_Schedule: FormGroup
  DataList_MailMessage_Schedule: Array<MailMessage_Interface> = []
  FormAdded_MailMessage_Schedule: Array<General_Interface> = []

  ReadData_MailMessage_Shcedule() {
    this.MailMessage_Service.GetRecord(4).subscribe(
      data => {
        this.DataList_MailMessage_Schedule = data
        this.OnInitail_Form()
      }
    )
  }

  get_MailMessageForm_Schedule_mailmessage_id() {
    return this.MailMessageForm_Schedule.get('mailmessage_id') as FormControl;
  }

  MailMessageForm_Schedule_Delete(id) {
    this.FormAdded_MailMessage_Schedule.splice(id, 1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  MailMessageForm_Schedule_Submit() {
    if (this.get_MailMessageForm_Schedule_mailmessage_id().value == "0") {
      this.Alertify_Service.ErrorMessage("پیام نامه انتخاب نمائید")
    }
    else {
      var Chekcer: boolean = false
      for (let detail of this.FormAdded_MailMessage_Schedule) {
        if (detail.id == Number(this.get_MailMessageForm_Schedule_mailmessage_id().value)) {
          Chekcer = true
          break
        }
      }

      if (Chekcer) {
        this.Alertify_Service.ErrorMessage("پیام نامه مورد نظر در لیست ثبت شده است")
      }
      else {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = Number(this.get_MailMessageForm_Schedule_mailmessage_id().value)
        temp.title = this.Find_MailMessage_Schedule(temp.id)
        this.FormAdded_MailMessage_Schedule.push(temp)
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
      }
    }

  }

  Find_MailMessage_Schedule(id: number) {
    for (let item of this.DataList_MailMessage_Schedule) {
      if (id == item.id) {
        return item.title
      }
    }
  }

  //#endregion


  modalRef_ScheduleAlert: any;
  ScheduleAlert_Dsc:String=''
  InProccessing: boolean = false

  SubmitAddNewLetter(ForceSubmit:number,template: TemplateRef<any>) {

    var indexerSchdule: number = 0
    var chegerSchdule: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule = true
          break;
        }

      }

      indexerSchdule++
    }


    var indexerSchdule_Super: number = 0
    var chegerSchdule_Super: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.seleted == true && itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule_Super = true
          break;
        }
      }


      indexerSchdule_Super++
    }





    if (this.Schedule_DataList.length == 0) {
      this.Alertify_Service.ErrorMessage("حداقل یک مورد تاریخ وارد نمائید")
    }
    else if (chegerSchdule) {
      this.Alertify_Service.ErrorMessage(" ردیف " + (indexerSchdule + 1) + " برنامه ریزی فاقد کارشناس می باشد ")
    }
    else if (chegerSchdule_Super) {
      this.Alertify_Service.ErrorMessage(" ردیف " + (indexerSchdule_Super + 1) + " برنامه ریزی فاقد سرپرست می باشد ")
    }

    else {
      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = this.inner_Letter_record.id

      if(ForceSubmit==1)
        this.modalRef_ScheduleAlert.hide()
      else
       this.modalRef.hide()

      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditSchduleForm(
        temp,
        this.Schedule_DataList,
        this.FormAdded_MailMessage_Schedule,
        ForceSubmit==1).subscribe(
          data => {

            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage(data.dsc + '')
            }
            else if (data.id == -2) {
              this.modalRef_ScheduleAlert = this.modalService.show(template);
              this.ScheduleAlert_Dsc=data.dsc
            }
            else {
              this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
              this.OnInitail_Form() 
            }

            this.InProccessing = false

            this.modalRef.hide()
          }
        )
    }
  }

  modalRef:any
  openModal_Code(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);

  }

}
